import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4573ef08")

_pushScopeId("data-v-4573ef08")
const _hoisted_1 = { class: "rnd-crns amplily-player" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_VideoPlayer = _resolveComponent("VideoPlayer")
  const _component_IframeVideoPlayer = _resolveComponent("IframeVideoPlayer")
  const _component_MomentBox = _resolveComponent("MomentBox")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      (!_ctx.video_urls.iframe_url || _ctx.video_urls.iframe_url == '')
        ? (_openBlock(), _createBlock(_component_VideoPlayer, {
            key: 0,
            poster: _ctx.video_urls.poster_url,
            video_urls: _ctx.video_urls,
            mid: null,
            subtitleUrls: _ctx.subtitle_urls,
            subtitles: _ctx.subtitles,
            continuefromTime: _ctx.end_time,
            duration: _ctx.duration,
            videoType: _ctx.ContentType.Trailer,
            title: _ctx.title,
            isTrailer: true,
            useDemoOverlay: _ctx.use_demo_overlay,
            logoOverlay: _ctx.overlay_logo,
            isgated: _ctx.isgated,
            ma: _ctx.ma,
            cta: _ctx.cta,
            usetheaterMode: _ctx.usetheaterMode
          }, null, 8, ["poster", "video_urls", "subtitleUrls", "subtitles", "continuefromTime", "duration", "videoType", "title", "useDemoOverlay", "logoOverlay", "isgated", "ma", "cta", "usetheaterMode"]))
        : (_openBlock(), _createBlock(_component_IframeVideoPlayer, {
            key: 1,
            iframe_url: _ctx.video_urls.iframe_url,
            poster: _ctx.video_urls.poster_url,
            duration: _ctx.duration
          }, null, 8, ["iframe_url", "poster", "duration"]))
    ]),
    (_ctx.showTimeline)
      ? (_openBlock(), _createBlock(_component_MomentBox, {
          key: 0,
          moments: _ctx.moments,
          title: _ctx.cta_text,
          resources: _ctx.resources,
          webinar_duration: _ctx.webinar_duration
        }, null, 8, ["moments", "title", "resources", "webinar_duration"]))
      : _createCommentVNode("", true)
  ]))
})